module.exports = __webpack_public_path__ + "./fonts/zapier-logo.988b6be800fed0d3d8a1cf0d12c17e83.svg";